import { render, staticRenderFns } from "./CompanyEditRules.vue?vue&type=template&id=f52c8128"
import script from "./CompanyEditRules.vue?vue&type=script&lang=js"
export * from "./CompanyEditRules.vue?vue&type=script&lang=js"
import style0 from "./CompanyEditRules.vue?vue&type=style&index=0&id=f52c8128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports